<template>
  <forgerock-template id="otp-page" :title="$t('SUI.page.otp.title')">

    <bootstrap-alerts :alerts="alerts"/>

    <stihl-section :title="$t('SUI.page.otp.subtitle')">
      <stihl-overlay :active="state === 'loading'">

        <form @submit.prevent="login">
          <label>{{ $t('SUI.page.otp.txtVerifyMail', { email: email }) }}</label>

          <otp-input id="otp"
                     :label="$t('SUI.page.otp.txtVerifyMail', {email: email})"
                     group-class="form-group"
                     :required="true"
                     autofocus
                     v-model="form.otp"
                     :validation-errors="v$.form.otp.$errors"
                     @keyup.enter="login"/>

          <div class="buttons">
            <button id="login" type="button" class="btn btn-primary" @click="login" :disabled="state === 'loading'">
              {{ $t('SUI.button.continue') }}
            </button>
            <button id="switchToOATH" type="button" class="btn btn-secondary"
                    @click="switchToOATH" :disabled="state === 'loading'" v-if="canSwitchToOATH">
              {{ $t('SUI.page.otp.switchToOATH') }}
            </button>
            <!--button id="back" type="button" class="btn btn-default" @click="back" v-if="false">
              {{ $t('SUI.button.back') }}
            </button-->
          </div>
        </form>

        <div class="pt-5">
          <h5>{{ $t('SUI.page.otp.spamTitle') }}</h5>
          <label class="m-0">{{ $t('SUI.page.otp.spamDetail') }}</label>
        </div>

        <div class="buttons">
          <button id="resend" type="button" class="btn btn-default" @click="resend" :disabled="state === 'loading'">
            {{ $t('SUI.page.otp.btnResend') }}
          </button>
          <help-menu/>
        </div>

      </stihl-overlay>
    </stihl-section>

  </forgerock-template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import StihlSection from '@/components/ui/StihlSection.vue';
import StihlOverlay from '@/components/ui/StihlOverlay.vue';
import OtpInput from '@/components/ui/OtpInput.vue';
import BootstrapAlerts, { Alert } from '@/components/ui/BootstrapAlerts.vue';
import useVuelidate from '@vuelidate/core';
import { validOTP } from '@/components/validators';
import { helpers, required } from '@vuelidate/validators';
import ForgerockTemplate from '@/components/layout/ForgerockTemplate.vue';
import HelpMenu from '@/components/ui/HelpMenu.vue';
import { fr } from '@/components/forgerock';
import { mapState } from 'pinia';
import { useLoginStore } from '@/components/login.store';
import { CallbackType, FRLoginFailure } from '@forgerock/javascript-sdk';

export default defineComponent({
  name: 'OTPPage',
  components: { HelpMenu, ForgerockTemplate, StihlSection, OtpInput, BootstrapAlerts, StihlOverlay },
  data() {
    return {
      form: {
        otp: '',
      },
      state: 'ready' as 'ready' | 'loading',
      alerts: [] as Alert[],
    };
  },

  computed: {
    ...mapState(useLoginStore, ['currentStep']),

    metadataCallback(): Record<string, any> {
      const cb = this.currentStep?.getCallbacksOfType(CallbackType.MetadataCallback);
      return cb && cb.length > 0 ? cb[0].getOutputValue() as Record<string, any> : {};
      //return this.currentStep?.getCallbackOfType(CallbackType.MetadataCallback)?.getOutputValue() as Record<string, any>;
    },
    email(): string {
      return this.metadataCallback?.email;
    },
    canSwitchToOATH(): boolean {
      return this.metadataCallback?.['has-oath'] === true;
    },

  },

  methods: {
    alert(message: string, _class?: string) {
      this.alerts.push({ message, class: _class });
    },
    back: () => (window.history.back()),
    login() {
      this.submit('login');
    },
    resend() {
      this.submit('resend');
    },
    switchToOATH() {
      this.submit('switch');
    },
    submit(to: 'login' | 'resend' | 'switch') {
      if (this.state === 'loading') {
        console.log('wait. loading');
        return;
      }

      this.alerts = [];

      if (to === 'login') {
        this.v$.$touch(); // trigger validation
        if (this.v$.$invalid) return console.error('validation failed', this.v$.$errors);
      }

      this.state = 'loading';

      const MAPPING = new Map<string, string>([
        ['login', this.form.otp],
        ['resend', '[RESEND]'],
        ['switch', '[OATH]'],
      ]);

      this.currentStep.getCallbackOfType(CallbackType.PasswordCallback).setInputValue(MAPPING.get(to));

      fr.submitStep(this.currentStep,
          (_s) => {
            if (to === 'login') {
              this.alert(this.$t('SUI.page.otp.msg.invalidOTP'));
            } else if (to === 'resend') {
              this.alert(this.$t('SUI.page.otp.msg.resendOk'), 'alert-info');
            }

            this.state = 'ready';
          },
          (e: FRLoginFailure) => {
            if (to === 'resend') {
              this.alert(this.$t('SUI.page.otp.msg.resendFail'));
            } else {
              this.alert(e.getMessage() ?? this.$t('SUI.error.generic'));
            }
            this.state = 'ready';
          });
    },
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      form: {
        // must match the fields in 'this.form'
        otp: {
          validOTP, required: helpers.withMessage(this.$t('SUI.validations.validOTP'), required),
        },
      }
    };
  },
});
</script>

<style scoped>
</style>
